__turbopack_context__.v({
  "root": "Chevron-module-scss-module__FH5PIa__root",
});
